import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { FormControl } from '../form-control.model';

@Component({
    selector: 'wncm-form-control-textarea',
    templateUrl: './form-control-textarea.component.html',
    styleUrls: ['../form-control.component.scss', './form-control-textarea.component.scss']
})
export class FormControlTextareaComponent extends FormControlComponent {
    @Input()
    displayHint: boolean;

    @Input()
    readOnly: boolean;

    @Input()
    label: string = null;

    constructor() {
        super();

        if (this.readOnly) {
            this.control.disable();
        }
    }
}
